import { queryOptions } from '@tanstack/react-query';
import { getCategoriesListFunction } from './getCategoriesListQueryFunction';

export const getCategoriesListQueryOptions = () => {
  return queryOptions({
    queryKey: ['category-list'],
    queryFn: () => getCategoriesListFunction(),
    enabled: true,
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
